
import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'Hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'toggle-click'
  ],
  setup (props, { emit }) {
    const toggleClick = () => {
      emit('toggle-click')
    }

    return {
      toggleClick
    }
  }
})
